export const MODAL_DIALOG__SOCIAL_SETTINGS = 'MODAL_DIALOG__SOCIAL_SETTINGS';
